<div class="table-responsive">
  <table class="table mb-2">
    <thead>
      <tr>
        <th scope="col">Report ID</th>
        <th scope="col">Report Name</th>
        <th scope="col">Generated Date</th>
        <th scope="col">Generated By</th>
        <th scope="col">Description</th>
        <th scope="col">Action</th>
      </tr>
    </thead>
    <tbody>
      @if (reports && reports.length > 0) {
        @for (report of reports; track report) {
          <tr>
            <th scope="row">#{{ report.version }}</th>
            <td>{{ report.template.name }}</td>
            <td>{{ report.created_at | date: 'longDate' }}</td>
            <td>{{ report.header_data["Prepared By"] }}</td>
            <td>{{ report.context_snippet }} <a (click)="openViewTextModal(viewConvtext, report.video_context)" class="link-success pointer">View More <i class="ri-arrow-right-line align-middle"></i></a></td>
            <td>
              <div class="d-flex gap-2">
                <button class="btn btn-sm btn-success edit-item-btn" (click)="openViewReport(report)" ngbTooltip="View Report" alt="View Report">
                  <i class="ri-eye-line align-middle"></i>
                </button>
                <button class="btn btn-sm btn-danger edit-item-btn" (click)="openDeleteReportModal(report, deleteReportModal)" ngbTooltip="Delete Report" alt="Delete Report">
                  <i class="ri-delete-bin-line align-middle"></i>
                </button>
              </div>
            </td>
          </tr>
        }
      }
      @if (reports && reports.length === 0) {
        <tr>
          <td [attr.colspan]="5" class="text-center border-0">
            <p>No generated reports found.</p>
            <button type="button" class="btn btn-primary" (click)="openGenerateNewReportModal()"><i class="ri-add-line align-bottom me-1"></i> Generate New Report </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
@if (reports.length > 0) {
  <div class="row justify-content-md-between align-items-md-center">
    <div class="col col-sm-6">
      <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite"> Showing {{startIndex}} to {{endIndex}} of {{allReports.length}} entries </div>
    </div>
    <div class="col col-sm-6">
      <div class="text-sm-right float-end listjs-pagination">
        <ngb-pagination [collectionSize]="allReports.length" [(page)]="currentPage" [pageSize]="pageSize" (pageChange)="getReports()"></ngb-pagination>
      </div>
    </div>
  </div>
}

<ng-template #viewConvtext let-modal>
  <div class="modal-content">
    <div class="modal-body">
      <div class="text-end">
        <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="modal.close('Close click')"></button>
      </div>
      <div class="mt-2">
        <p [dir]="isRtl(video_context) ? 'rtl' : 'ltr'">{{ video_context }}</p>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #deleteReportModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <div class="mt-2 text-center">
        <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>

        <div class="alert alert-danger">
          <p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
        </div>

        <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          <h4>Are you sure you want to delete this <span class="fw-semibold text-warning">{{ selectedReport.template.name }} Report</span>?</h4>
        </div>

        <div class="text-start mb-0 p-3">
          @if (selectedReport.video_context) {
            <div class="mb-3">
              <h6 class="fs-12 text-uppercase text-muted fw-semibold mb-1">Context</h6>
              <p class="fs-13 mb-0 text-truncate-three-lines" [ngClass]="isRtl(selectedReport.video_context) ? 'text-end' : ''" [dir]="isRtl(selectedReport.video_context) ? 'rtl' : 'ltr'">
                {{ selectedReport.video_context }}
              </p>
            </div>
          }
          @if (selectedReport.languages?.length) {
            <div class="mb-3">
              <h6 class="fs-12 text-uppercase text-muted fw-semibold mb-1">Languages</h6>
              <p class="fs-13 mb-0">
                @for (lang of selectedReport.languages; track lang; let isLast = $last) {
                  <span class="badge badge-soft-primary me-1 p-0">
                    {{ lang.name }}@if (!isLast) {
                    <span>,</span>
                  }
                </span>
              }
            </p>
          </div>
        }
        @if (selectedReport.header_data) {
          <div>
            <h6 class="fs-12 text-uppercase text-muted fw-semibold mb-2">Metadata</h6>
            <div class="row g-2">
              @for (item of selectedReport.header_data | keyvalue; track item) {
                @if (item.value) {
                  <div class="col-md-6">
                    <div class="d-flex align-items-center">
                      <i class="ri-checkbox-blank-circle-fill text-warning fs-8 me-2"></i>
                      <span class="fs-12 text-muted me-1">{{ item.key }}:</span>
                      <span class="fs-12 fw-medium">{{ item.value }}</span>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        }

      </div>
    </div>

    <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
      <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="closeModal()">Close</button>
      <button type="button" class="btn w-sm btn-danger btn-load" (click)="deleteReport()" [disabled]="submitted && spinner">
        <span class="d-flex justify-content-center">
          @if (submitted && spinner) {
            <span class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </span>
          }
          <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Yes, Delete It!</span>
        </span>
      </button>
    </div>
  </div>
</div>
</ng-template>

<ng-template #responseModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="mt-2">
        @if (success) {
          <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
        }
        @if (!success) {
          <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
        }
        <h4 class="mb-3 mt-4">{{ message }}</h4>
        <p class="text-muted mx-4 mb-0">{{ message }}</p>
      </div>
    </div>
  </div>
</ng-template>

<app-view-generated-report #viewReport (updateReportsEvent)="updateReports($event)"></app-view-generated-report>
<app-generate-new-report #generateNewReport [activity_type]="activity_type" [page_source]="page_source" [page_data]="page_data" (updateReportsEvent)="updateReports($event)"></app-generate-new-report>